export const countryOptions = [
  {
    label: 'Argentina',
    value: 'Argentina',
  },
  {
    label: 'India',
    value: 'India',
  },
  {
    label: 'New Zealand',
    value: 'New Zealand',
  },
  {
    label: 'Russia',
    value: 'Russia',
  },
  {
    label: 'Sweden',
    value: 'Sweden',
  },
  {
    label: 'United States',
    value: 'United States',
  },
  {
    label: 'Uruguay',
    value: 'Uruguay',
  },
  {
    label: 'Zimbabwe',
    value: 'Zimbabwe',
  },
];
